import React from "react";
import { Helmet } from "react-helmet";
import HeroSlider from "../components/HeroSlider";
import { useTranslation } from "react-i18next";

const SmallClaimCourt = () => {
  const {t} = useTranslation();
  return (
    <>
      <div className="home-page">
        <Helmet>
          <title>
            Small Claim Court | Min & Ying Legal Services Professional Corporation
          </title>
          
          <meta
            name="description"
            content="Small Claim Court | Min & Ying Legal Services Professional Corporation"
          />
        </Helmet>
        <HeroSlider/>

        <section className="card py-5 px-3 border-0 container">
          <div className="row">
            <div className="col-lg-7">
              <div className="card-body">
                <h6 className="guide-text mb-4">{t('smallClaimCourt.title')}</h6>
                <p className="fw-normal">
                  {t('smallClaimCourt.summary')}
                </p>
                <ol style={{paddingLeft: '1.5rem'}}>
                  <li>{t('smallClaimCourt.service1')}</li>
                  <li>{t('smallClaimCourt.service2')}</li>
                  <li>{t('smallClaimCourt.service3')}</li>
                  <li>{t('smallClaimCourt.service4')}</li>
                </ol>
              </div>
            </div>

            <div className="col-lg-5 d-flex align-items-center justify-content-center">
              <div>
                <img
                  src="/assets/services/small-claim.webp"
                  className="intro-img img-fluid d-block rounded-2"
                  alt=" a gavel, scales of justice, and law books"
                  style={{ maxHeight: "300px" }}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SmallClaimCourt;